<template>
  <div>
    <table-view
      ref="tableList"
      :isSearchLoading="isAllLoad"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      @searchChange="handleSearchChange"
      @pageChange="params => _getTableData(params)"
      tableCardTitle="Customer List"
      :right-btn-options="{
        text: 'Create New Customer',
        isHavePermission: createBtn,
      }"
      @changeTitleActionBtn="
        $store.state.source === 1
          ? $router.push({ name: 'createCustomer' })
          : $router.push({ name: 'createCssCustomer' })
      "
    >
      <template v-slot:name="{ tableRow }">
        <a href="javascript:void (0)" @click="handleHrefInfoPage(tableRow.row)">
          {{ tableRow.row.name }}
        </a>
      </template>
      <template v-slot:customerType="{ tableRow }">
        {{ tableRow.row.customerType | customerType }}
      </template>
      <template v-slot:totalAr="{ tableRow }">
        {{ tableRow.row.totalAr | formatAmount }}
      </template>
      <!--      <template v-slot:creditLimit="{ tableRow }">
        {{ tableRow.row.creditLimit | formatAmount }}
      </template>-->
      <template v-slot:action="{ tableRow }">
        <el-tooltip
          class="item"
          effect="dark"
          content="Move to Blacklist"
          placement="top"
        >
          <a
            href="javascript: void (0)"
            v-if="tableRow.row.status === 1"
            @click="handleAddBlackListBtn(tableRow.row)"
          >
            <img
              src="./images/move to Blacklist.png"
              alt=""
              srcset=""
              width="20px"
              height="20px"
            />
          </a>
        </el-tooltip>
        <el-popconfirm
          title="Confirm to  remove？"
          confirm-button-text="confirm"
          v-if="tableRow.row.status === 2"
          cancel-button-text="cancel"
          @confirm="handleRemoveBlackListBtn(tableRow.row)"
        >
          <el-tooltip
            class="item"
            effect="dark"
            content="Remove Blacklist"
            placement="top"
            slot="reference"
          >
            <img
              src="./images/Remove Blacklist.png"
              alt=""
              srcset=""
              width="20px"
              height="20px"
            />
          </el-tooltip>
        </el-popconfirm>
        <el-tooltip
          class="item"
          effect="dark"
          content="Add to My Quick View"
          placement="top"
        >
          <a
            v-if="tableRow.row.myWatchList === 2"
            href="javascript: void (0)"
            @click="handleMoveBtn(tableRow.row)"
            style="margin-left: 16px"
          >
            <img
              src="./images/Move to My Watchlist.png"
              alt=""
              srcset=""
              width="20px"
              height="20px"
            />
          </a>
        </el-tooltip>
        <el-popconfirm
          title="Confirm to  remove？"
          confirm-button-text="confirm"
          v-if="tableRow.row.myWatchList === 1"
          cancel-button-text="cancel"
          @confirm="handleRemoveBtn(tableRow.row)"
        >
          <el-tooltip
            class="item"
            effect="dark"
            content="Remove from My Watchlist"
            placement="top"
            slot="reference"
          >
            <a href="javascript:void (0);" style="margin-left: 16px">
              <img
                src="./images/Remove from My Watchlist.png"
                alt=""
                srcset=""
                width="20px"
                height="20px"
              />
            </a>
          </el-tooltip>
        </el-popconfirm>
        <el-tooltip
          class="item"
          effect="dark"
          content="Add Customer Type"
          placement="top"
          slot="reference"
          v-if="$store.state.source !== 2"
        >
          <a
            href="javascript:void (0);"
            style="margin-left: 16px"
            @click="
              dialogCustomerType = true
              selectItem = tableRow.row
            "
          >
            <img
              src="./images/add-circle-outline.svg"
              alt=""
              srcset=""
              width="20px"
              height="20px"
            />
          </a>
        </el-tooltip>
      </template>
    </table-view>

    <el-dialog
      title="Move to Blacklist"
      :visible.sync="dialogVisible"
      width="500px"
      @close="handleDialogClose"
    >
      <el-card>
        <el-form ref="form" :model="form" label-width="90px" :rules="rules">
          <el-form-item label="Comments" prop="blackListReason">
            <el-input
              type="textarea"
              v-model="form.blackListReason"
              :rows="4"
              maxlength="200"
              show-word-limit
            />
          </el-form-item>
        </el-form>
      </el-card>
      <div slot="footer">
        <customize-button
          @click="dialogVisible = false"
          style="margin-right: 20px"
        >
          Cancel
        </customize-button>
        <customize-button type="primary" @click="handleAddBlackList">
          Confirm
        </customize-button>
      </div>
    </el-dialog>

    <el-dialog
      title="Add Customer Type"
      :visible.sync="dialogCustomerType"
      :close-on-click-modal="false"
      width="500px"
      :before-close="handleClose"
    >
      <div>
        <el-select
          placeholder="Please select customer type"
          v-model="customerType"
          style="width: 100%; margin-bottom: 20px"
        >
          <el-option label="Trade" value="1"></el-option>
          <el-option label="Eaas" value="2"></el-option>
          <el-option label="Saas" value="3"></el-option>
        </el-select>
        <el-select
          placeholder="Please select CCA"
          v-model="cca"
          style="width: 100%"
        >
          <el-option
            v-for="item in ccaList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCustomerType = false">Cancel</el-button>
        <el-button type="primary" @click="handleClickCustomerTypeBtn">
          Confirm
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSelectList } from '@/api'
import {
  getTableData,
  addBlackList,
  addToWatchList,
  removeWatchList,
  removeBlackList,
  getAddlog,
  addCustomerType,
} from './api'
import { vagueActiveName } from 'views/customer-mangement/detail/info/basic-profile/api'
import { mapState } from 'vuex'
const selectList = ['Country', 'Region', 'CCA', 'Bu', 'Geo']

export default {
  data() {
    const searchModel = [
      {
        label: 'Customer #',
        type: 'input',
        key: 'code',
      },
      {
        label: 'Customer Name',
        type: 'input',
        key: 'name',
      },
      {
        label: 'BU',
        type: 'select',
        placeholder: 'All',
        key: 'bu',
        selectList: [],
      },
      {
        label: 'Onshore/Offshore',
        type: 'select',
        placeholder: 'All',
        key: 'onOffshore',
        selectList: [
          { id: 1, name: 'Onshore' },
          { id: 2, name: 'Offshore' },
        ],
      },
      {
        label: 'GEO',
        type: 'select',
        key: 'geo',
        placeholder: 'All',
        selectList: [],
      },
      {
        label: 'Region',
        type: 'select',
        key: 'region',
        placeholder: 'All',
        selectList: [],
      },
      {
        label: 'Sales Country',
        type: 'select',
        placeholder: 'All',
        key: 'country',
        selectList: [],
      },
      // {
      //   label: 'State',
      //   type: 'input',
      //   key: 'state',
      // },
      // {
      //   label: 'City',
      //   type: 'input',
      //   key: 'city',
      // },
      {
        label: 'CCA',
        type: 'select',
        placeholder: 'All',
        key: 'cca',
        selectList: [],
      },
      // {
      //   label: 'Business Entity',
      //   type: 'select',
      //   placeholder: 'All',
      //   key: 'businessEntity',
      //   selectList: [
      //     { id: 1, name: 'Parent' },
      //     { id: 2, name: 'Subsidiary' },
      //   ],
      // },
      // {
      //   label: 'Account Status',
      //   type: 'select',
      //   placeholder: 'All',
      //   key: 'accountStatus',
      //   selectList: [
      //     { id: 1, name: 'Active' },
      //     { id: 3, name: 'Inactive' },
      //   ],
      // },
      {
        label: 'Customer Type',
        type: 'select',
        placeholder: 'All',
        key: 'customerType',
        selectList: [
          { id: 1, name: 'Trade' },
          { id: 2, name: 'Eaas' },
          { id: 3, name: 'Saas' },
        ],
      },
    ]
    const tableModel = [
      {
        label: 'Customer Name',
        slotName: 'name',
      },
      {
        label: 'Customer #',
        prop: 'code',
      },
      {
        label: 'Customer Type',
        slotName: 'customerType',
      },
      {
        label: 'Onshore/Offshore',
        prop: 'onOffshoreStr',
      },
      // {
      //   label: 'City',
      //   prop: 'city',
      // },
      {
        label: 'Sales Country',
        prop: 'country',
      },
      {
        label: 'GEO',
        prop: 'geo',
      },
      {
        label: 'Region',
        prop: 'region',
      },
      {
        label: 'BU',
        prop: 'bu',
      },
      // // Total AR
      {
        label: 'Total AR',
        slotName: 'totalAr',
      },
      {
        label: 'Credit limit',
        prop: 'creditLimit',
      },
      // // Credit limit
      {
        label: 'Action',
        slotName: 'action',
        width: 150,
      },
    ]
    return {
      searchModel: searchModel,
      tableModel: tableModel,
      customerInfo: {},
      isAllLoad: true,
      tableData: [],
      pages: {},
      dialogVisible: false,
      form: {
        blackListReason: '',
      },
      rules: {
        blackListReason: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
      },
      createBtn: false,
      dialogCustomerType: false,
      customerType: '',
      selectItem: {},
      cca: '',
      ccaList: [],
    }
  },
  computed: {
    ...mapState({
      source: state => state.source,
    }),
  },
  filters: {
    customerType(val) {
      if (val === 1) {
        return 'Trade'
      } else if (val === 2) {
        return 'Eaas'
      } else if (val === 3) {
        return 'Saas'
      }
    },
  },
  created() {
    this.createBtn = this.$storage.getItem('btn')?.['Customer-Add']
    // this.remoteActiveName()
    this.getAllSelect()
  },
  mounted() {
    if (this.source === 2) {
      this.tableModel.splice(2, 1)
    }
    this.initTable()
  },
  methods: {
    handleClose(done) {
      this.selectItem = {}
      this.customerType = ''
      done()
    },
    async handleClickCustomerTypeBtn() {
      if (!this.customerType || !this.cca) {
        this.$message.error('Please select customer type and CCA')
        return
      }
      try {
        await addCustomerType({
          id: this.selectItem.id,
          cca: this.cca,
          customerType: this.customerType,
        })
        this.$message.success('success')
        this.dialogCustomerType = false
        this.initTable()
      } catch (err) {
        console.error(err)
      }
    },
    // 模糊查询Credit Analyst
    async remoteActiveName() {
      try {
        this.itCodeList = await vagueActiveName()
        this.searchModel[3].selectList = this.itCodeList.map(item => ({
          id: item.username,
          name: item.username,
          value: item.username,
        }))
      } catch (err) {
        console.log(err)
      }
    },
    handleDialogClose() {
      this.$refs.form.resetFields()
      this.formId = ''
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async handleHrefInfoPage({
      id,
      name,
      address,
      country,
      code,
      city,
      state,
    }) {
      let routeUrl = this.$router.resolve({
        path: `/customer-management/${id}/info`, // 对应路由
      })
      window.open(routeUrl.href, '_blank')
      const params = {
        companyId: id,
      }
      await getAddlog(params)
      await this.$storage.setItem('customerInfo', {
        name,
        address,
        code,
        state,
        city,
        country,
      })
    },
    getAllSelect() {
      const pro = selectList.map(item => this._getSelectList(item))
      Promise.all(pro)
        .then(res => {
          if (res.length === selectList.length) {
            const [countryList, regionList, ccaList, buList, geoList] = res
            this.ccaList = ccaList
            for (let i = 0; i < this.searchModel.length; i++) {
              const item = this.searchModel[i]
              if (item.label === 'Region') {
                item['selectList'] = regionList
              } else if (item.label === 'Sales Country') {
                item['selectList'] = countryList
              } else if (item.label === 'CCA') {
                item['selectList'] = ccaList
              } else if (item.key === 'bu') {
                item['selectList'] = buList
              } else if (item.label === 'GEO') {
                item['selectList'] = geoList
              }
            }
            this.isAllLoad = false
          }
        })
        .catch(err => {
          console.error(`search 列表查询错误:${err}`)
        })
    },
    async _getSelectList(typeMark) {
      try {
        return await getSelectList(typeMark)
      } catch (err) {
        console.error(err)
      }
    },
    async _getTableData(params) {
      try {
        const { data, page } = await getTableData(params)
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
    async handleAddBlackListBtn({ id }) {
      this.formId = id
      this.dialogVisible = true
    },
    async handleAddBlackList() {
      try {
        const valid = await this.$refs.form.validate()
        if (valid) {
          await addBlackList({
            companyId: this.formId,
            blackListReason: this.form.blackListReason,
            blackListUsername: this.$storage.getItem('itCode'),
          })
          this.$message.success('success')
          this.initTable()
          this.dialogVisible = false
        }
      } catch (err) {
        console.error(err)
      }
    },
    async handleRemoveBlackListBtn({ id }) {
      try {
        await removeBlackList(id)
        this.$message.success('Success')
        this.initTable()
      } catch (err) {
        console.error(err)
      }
    },
    async handleMoveBtn(data) {
      try {
        const _params = {
          companyId: data.id,
        }
        await addToWatchList(_params)
        this.$message.success('Success')
        this.initTable()
      } catch (err) {
        console.error(err)
      }
    },
    async handleRemoveBtn(data) {
      try {
        const _params = {
          companyId: data.id,
        }
        await removeWatchList(_params)
        this.$message.success('Success')
        this.initTable()
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>

<style scoped lang="less"></style>
